import { useState, useEffect } from 'react';
import { devices } from 'apis';
import { store } from 'store';
import { useMe } from 'hooks/useMe';

export const useIssueActivationToken = () => {
    const [token, setToken] = useState(null);
    const [userId, setUserId] = useState(null);
    const [error, setError] = useState(null);
    const [refetch, toggle] = useState(false);
    const state = store.getState();
    const whoami = useMe();

    useEffect(() => {
        if (whoami?.whoami?.userId) {
            setUserId(whoami?.whoami?.userId);
        }
    }, [whoami]);

    const triggerRefetch = () => {
        toggle((prev) => !prev);
    };

    const resetState = () => {
        setToken(null);
        setError(null);
    };

    useEffect(() => {
        const fetchAsync = async () => {
            if (userId) {
                try {
                    resetState();
                    console.log('token', userId, state.auth.accessToken);
                    const res = await devices.issueActivationToken({ userId, accessToken: state.auth.accessToken });
                    setToken(res.token);
                } catch (error) {
                    setError(error);
                }
            }
        };
        fetchAsync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, refetch]);

    return {
        triggerRefetch,
        setUserId,
        token,
        error
    };
};
